var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoMagnifier = function SvgIcoMagnifier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m22.04 20.156 5.71 5.71-1.885 1.886-5.71-5.71a11.95 11.95 0 0 1-7.489 2.625c-6.624 0-12-5.376-12-12s5.376-12 12-12 12 5.376 12 12c0 2.832-.983 5.436-2.625 7.489m-2.674-.99a9.3 9.3 0 0 0 2.633-6.5 9.33 9.33 0 0 0-9.333-9.333 9.33 9.33 0 0 0-9.333 9.334A9.33 9.33 0 0 0 12.666 22a9.3 9.3 0 0 0 6.5-2.634z"
  })));
};
export default SvgIcoMagnifier;